<div class="performance centerWidth">
    <div style="direction: rtl;">
        <img src="assets/images/op1.svg">
        <img src="assets/images/op1.svg">
        <div style="{{'direction:'+getDirection() }}">
            <h2>{{performanc != null ? performanc['title'] : ''}}</h2>
            <p>{{performanc != null  ? performanc['text'] : ''}}</p>
            <a target="_blank" style="position: relative;z-index: 1;" *ngIf="performanc != null  && performanc['url']!=null" [href]="performanc['url']">
            <button class="button register-btn" >
                <span i18n="@@Start Free">Start Free</span>
                <i *ngIf="getDirection()=='rtl'" class="pi pi-angle-left"></i>
                <i *ngIf="getDirection()=='ltr'" class="pi pi-angle-right"></i>
            </button>
            </a>
        </div>
    </div>
</div>
